import React, { useRef, useState } from "react";

import { ReactComponent as BackButton } from "../../../../assests/back-arrow.svg";
import {
  Col,
  Form,
  List,
  Row,
  Typography,
  Image,
  Button,
} from "../../../../components/common/utils/antd-imports/AntdImports";
import { useNavigate } from "react-router-dom";
import { ReactComponent as RetryIcon } from "../../../../assests/check-book-retry-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assests/check-book-delete-icon.svg";
import { ReactComponent as UploadImage } from "../../../../assests/upload-image.svg";
import FloatingInput from "../../../../components/common/float-input/FloatInput";
import { CloseOutlined } from "@ant-design/icons";
import BankCheck from "../../../../assests/images/check-image.jpg";
const { Text } = Typography;
const CheckPaymentVersion = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [submittedData, setSubmittedData] = useState(null);
  const [isCheckSubmitted, setIsCheckSubmitted] = useState(false);
  const fileInputRef = useRef(null);
  const [isCheckOpen, setIsCheckOpen] = useState(false);
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [isFrontView, setIsFrontView] = useState(false);
  const [imageFrontView, setImageFrontView] = useState(null);
  const [imageBackView, setImageBackView] = useState(null);
  const [showNumber, setShowNumber] = useState(false);
  const instructions = [
    "Ensure images are clear and legible.",
    "The check must be properly endorsed on the back.",
    "Your payment will be processed once the check is verified.",
  ];

  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    const img = new window.Image();
    const objectUrl = URL.createObjectURL(file);
    img.src = objectUrl;
    img.onload = () => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {};
      if (isFrontView) {
        setImageFrontView(file);
      } else {
        setImageBackView(file);
      }

      URL.revokeObjectURL(objectUrl);
    };
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append("payer_name", values.payer_name);
    formData.append("pay_to_order", values.pay_to_order);
    formData.append("check_amount", values.check_amount);
    formData.append("check_date", values.check_date);
    formData.append("check_validity", values.check_validity);
    formData.append("check_bank", values.check_bank);
    formData.append("check_number", values.check_number);
    formData.append("bank_routing_number", values.bank_routing_number);
    formData.append("account_number", values.account_number);
    setSubmittedData(values);
    form.resetFields();
    setIsCheckOpen(false);
    setIsCheckSubmitted(true);
  };
  return (
    <div className="check-payment-main-container">
      <Row className="complete-campaign-text-row">
        <Col>
          <BackButton
            onClick={(e) => {
              navigate(-1);
            }}
            className="back-arrow-payment-main"
          />
        </Col>
        <Col>
          <Text className="complete-campaign-text">Upload Check Images</Text>
        </Col>
      </Row>
      <Form form={form} onFinish={handleSubmit}>
        <div>
          <Row className="check-upload-front-back-row">
            <Col className="check-upload-front-col" xs={23}>
              {imageFrontView ? (
                <>
                  <Row className="check-front-view-text-row">
                    <Text className="check-front-view-text">Front View</Text>
                  </Row>
                  <img
                    src={URL.createObjectURL(imageFrontView)}
                    alt="alt-image"
                    className="check-upload-container"
                    style={{
                      border: imageFrontView && 0,
                    }}
                  ></img>
                  <div style={{ display: "flex" }}>
                    <div
                      className="billboard-delete-image"
                      onClick={(e) => {
                        fileInputRef.current?.click();
                        setIsFrontView(true);
                      }}
                    >
                      <RetryIcon />
                    </div>
                    <div
                      className="billboard-delete-image"
                      onClick={(e) => {
                        setImageFrontView(null);
                        fileInputRef.current.value = null;
                      }}
                    >
                      <DeleteIcon />
                    </div>
                  </div>
                </>
              ) : (
                <div className="check-upload-container">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      fileInputRef.current?.click();
                      setIsFrontView(true);
                    }}
                  >
                    <Row className="check-upload-section-text-row">
                      <UploadImage />
                    </Row>
                    <Row className="check-upload-section-text-row">
                      <Text className="check-upload-text">
                        Upload front image
                      </Text>
                    </Row>
                  </div>
                </div>
              )}
            </Col>
            <Col className="check-upload-back-col" xs={23}>
              {imageBackView ? (
                <>
                  <Row className="check-front-view-text-row">
                    <Text className="check-front-view-text">Rear View</Text>
                  </Row>
                  <img
                    src={URL.createObjectURL(imageBackView)}
                    alt="alt-image"
                    className="check-upload-container"
                    style={{
                      border: imageBackView && 0,
                    }}
                  ></img>
                  <div style={{ display: "flex" }}>
                    <div
                      className="billboard-delete-image"
                      onClick={(e) => {
                        fileInputRef.current?.click();
                        setIsFrontView(false);
                      }}
                    >
                      <RetryIcon />
                    </div>
                    <div
                      className="billboard-delete-image"
                      onClick={(e) => {
                        setImageBackView(null);
                        fileInputRef.current.value = null;
                      }}
                    >
                      <DeleteIcon />
                    </div>
                  </div>
                </>
              ) : (
                <div className="check-upload-container">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      fileInputRef.current?.click();
                      setIsFrontView(false);
                    }}
                  >
                    <Row className="check-upload-section-text-row">
                      <UploadImage />
                    </Row>
                    <Row className="check-upload-section-text-row">
                      <Text className="check-upload-text">
                        Upload back image
                      </Text>
                    </Row>
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row className="check-instructions-row">
            <List
              dataSource={instructions}
              renderItem={(item, index) => (
                <List.Item>
                  {index + 1}. {item}
                </List.Item>
              )}
              className="check-instructions-list"
            />
          </Row>
          <Row className="check-user-details-container" gutter={[16, 16]}>
            <Col span={23}>
              <Form.Item
                name="payer_name"
                rules={[
                  {
                    required: true,
                    message: "Payer Name is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Payer Name `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="check-user-details-container">
            <Col span={23}>
              <Form.Item
                name="pay_to_order"
                rules={[
                  {
                    required: true,
                    message: "Pay to the Order of(TO) is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Pay to the Order of (To) Name `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="check-user-details-container">
            <Col span={23}>
              <Form.Item
                name="check_amount"
                rules={[
                  {
                    required: true,
                    message: "Check Amount is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Check Amount  `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="check-user-details-container" gutter={[16, 16]}>
            <Col span={23}>
              <Form.Item
                name="check_date"
                rules={[
                  {
                    required: true,
                    message: "Check Date is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Check Date `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="check-user-details-container">
            <Col span={23}>
              <Form.Item
                name="check_validity"
                rules={[
                  {
                    required: true,
                    message: "Check Validity is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Check Validity `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="check-user-details-container">
            <Col span={23}>
              <Form.Item
                name="check_bank"
                rules={[
                  {
                    required: true,
                    message: "Check Bank is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Check Bank  `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="check-user-details-container" gutter={[16, 16]}>
            <Col span={23}>
              <Form.Item
                name="check_number"
                rules={[
                  {
                    required: true,
                    message: "Check Number is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Check Number  `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="check-user-details-container" gutter={[16, 16]}>
            <Col span={23}>
              <Form.Item
                name="bank_routing_number"
                rules={[
                  {
                    required: true,
                    message: "Bank Routing Number is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Bank Routing Number `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="check-user-details-container" gutter={[16, 16]}>
            <Col span={23}>
              <Form.Item
                name="account_number"
                rules={[
                  {
                    required: true,
                    message: "Amount Number is required!",
                  },
                ]}
              >
                <FloatingInput
                  className="billboard-input-feild"
                  label={
                    <>
                      {`Account Number `}
                      {star}
                    </>
                  }
                  customStyles={floatingInputStyles}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="check-user-details-container">
            <Text
              className="check-footer-text-links"
              onClick={() => setShowNumber(true)}
            >
              Need help locating your check details?
            </Text>
          </Row>
          <Row
            className={
              showNumber
                ? "sample-check-image-container show-check-image"
                : "sample-check-image-container"
            }
            gutter={[16, 16]}
          >
            {showNumber && (
              <div className="check-image-wrapper">
                <CloseOutlined
                  onClick={() => setShowNumber(false)}
                  className="check-close-icon"
                />
                <Image
                  src={BankCheck}
                  preview={false}
                  className="demo-check-image"
                />
              </div>
            )}
          </Row>
          <Row className="check-payments-button-version-row" gutter={[16, 16]}>
            <Col span={11}>
              <Button
                type="primary"
                className="check-payments-button-version-cancel"
                onClick={() => navigate(-1)}
              >
                <Text className="check-payments-button-version-cancel-text">
                  Cancel
                </Text>
              </Button>
            </Col>
            <Col span={11}>
              <Button
                className="check-payments-button-version-submit"
                type="primary"
              >
                <Text className="check-payments-button-version-submit-text">
                  Submit
                </Text>
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
      <input
        type="file"
        accept="image/jpeg, image/jpg"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleImageChange}
      />
    </div>
  );
};
export default CheckPaymentVersion;
